import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Dialog } from 'primeng/dialog';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FeedbackService } from '../../../services/feedback.service';
import { TokenStorageService } from '../../../core/services/token-storage.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { Router } from '@angular/router';
import { LoaderService } from '../../../services/loader.service';
@Component({
  selector: 'app-new-password-dialog',
  imports: [Dialog, FormsModule, ToastModule],
  templateUrl: './new-password-dialog.html',
  styleUrl: './new-password-dialog.scss',
  providers: [MessageService],
})
export class NewPasswordDialog {
  private ref = inject(DynamicDialogRef);
  private config = inject(DynamicDialogConfig);
  private messageService = inject(MessageService);
  private loaderService = inject(LoaderService);
  messagePopupVisible: boolean = false;
  email = this.config.data?.email || '';
  private tokenStorage = inject(TokenStorageService);
  userId = this.config.data?.userId || this.tokenStorage.getUser()?.id || 0;
  password: string = '';
  reenter: string = '';
  showConfirmation: boolean = false;
  private router = inject(Router);
  private feedbackService = inject(FeedbackService);
  showCurrentPasswordDialog: boolean = true; 
  currentPassword: string = '';
  showCurrentPassword: boolean = false;

  toggleCurrentPasswordVisibility(): void {
    this.showCurrentPassword = !this.showCurrentPassword;
  }

  verifyCurrentPassword(): void {
  if (!this.currentPassword) {
    this.messageService.add({
      severity: 'error',
      summary: 'error',
      detail: 'current password cannot be empty',
    });
    return;
  }
  this.loaderService.show();
  this.feedbackService.verifyCurrentPassword(this.userId, this.currentPassword).subscribe({
      next: (res) => {
        if (res?.data?.isMatch) {
          this.messageService.add({
            severity: 'success',
            summary: 'success',
            detail: 'password verified',
          });
          this.showCurrentPasswordDialog = false;
          this.loaderService.hide();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'error',
            detail: 'current password is incorrect.please try again',
          });
          this.loaderService.hide();
        }
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'error',
          detail: 'failed to verify current password',
        });
      },
    });
  }

  Continue() {
    if (!this.password) {
      this.messageService.add({
        severity: 'error',
        summary: 'error',
        detail: 'password cannot be empty',
      });
      return;
    }
    const validation = this.validatePassword(this.password);
    if (!validation.valid) {
      this.messageService.add({
        severity: 'error',
        summary: 'invalid password',
        detail: validation.message,
      });
      return;
    }
    if (!this.reenter) {
      this.messageService.add({
        severity: 'error',
        summary: 'error',
        detail: 'please re-enter password',
      });
      return;
    }
    if (this.password !== this.reenter) {
      this.messageService.add({
        severity: 'error',
        summary: 'error',
        detail: 'passwords do not match',
      });
      return;
    }

    this.feedbackService
      .updateUserPassword(this.userId, this.password as any)
      .subscribe({
        next: () => {
          this.showConfirmation = true;
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'error',
            detail: 'failed to update password',
          });
        },
      });
  }

  closePopup() {
    this.ref.close();
  }
  closeConfirmation() {
    this.showConfirmation = false;
    this.ref.close({ password: this.password });
    localStorage.clear();
    sessionStorage.clear();
    setTimeout(() => {
      this.ref.close(true);
      this.router.navigateByUrl('/sign-in');
    }, 1000);
  }
  validatePassword(password: string): { valid: boolean; message: string } {
    if (/\s/.test(password)) {
      return { valid: false, message: 'password cannot contain spaces' };
    }
    if (password.length < 8) {
      return {
        valid: false,
        message: 'password must be at least 8 characters long',
      };
    }
   /*  if (!/[A-Z]/.test(password)) {
      return {
        valid: false,
        message: 'password must contain at least one uppercase letter',
      };
    } */
    if (!/[a-z]/.test(password)) {
      return {
        valid: false,
        message: 'password must contain at least one lowercase letter',
      };
    }
    if (!/[0-9]/.test(password)) {
      return {
        valid: false,
        message: 'password must contain at least one number',
      };
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      return {
        valid: false,
        message: 'password must contain at least one special character',
      };
    }
    return { valid: true, message: '' };
  }

  showPassword: boolean = false;
showRePassword: boolean = false;
 
togglePasswordVisibility(): void {
  this.showPassword = !this.showPassword;
}

toggleRePasswordVisibility(): void {
  this.showRePassword = !this.showRePassword;
}
}
